import axios from "axios";
import { useState } from 'react';
import { NotificationManager } from "react-notifications";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import AddPortfolioTabData from "./ProtofolioTabData";


const initialData = {
  property: [],
  name: "",
  description: ""

};

const AddPortfolioModal = ({ showModal, onClose, onCallApi, id, from }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);

    const values = {
      property: formData.property.map((p) => ({
          property_id: p.id,
          property_name: p.property_name,
      })),
      name: formData.name,
      description: formData.description,
    };

    const dataToSend =
      from === "contact"
        ? { ...values, contact_id: id, list_type: "contact" }
        : { ...values, company_id: id, contact_id: formData.contactId, list_type: "company" };

    console.log(dataToSend);

    axios
      .post(`${BASE_URL}/add-portfolio`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors);
        if (
          err.response?.data?.message &&
          err.response?.data?.message !== "Too Many Attempts."
        ) {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };


  return (
    <Modal width="620px" title={`Add Portfolio`} desc={`Add the Portfolio information.`} show={showModal} onClose={handleClose}>
      <AddPortfolioTabData
        formData={formData}
        error={error}
        isSidebarOpen={isSidebarOpen}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        from={from}
        id={id}
        onSetError={(value) => setError(value)}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        showModal={showModal}
        disable={disable}
      />
    </Modal>
  );
};

export default AddPortfolioModal;